<template>
  <div class="after-sale-type">
    <navbar title="选择售后类型" left-text show-home></navbar>
    <div class="after-sale-type-wrapper">
      <sku-details :sku="afterSaleSku"></sku-details>
      <div class="check-types">
        <button :disabled="!type.is_allow" class="" v-for="(type, index) in typeList" :key="index" @click="apply(type.service_type)">
          <div class="type-intro">
            <img :src="type.icon" alt="">
            <span>{{type.name}}</span>
          </div>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import Navbar from '../components/NavBar'
import SkuDetails from '../components/afterSaleStatus/SkuDetails'
import { mapState } from 'vuex'
export default {
  name: 'afterSaleType',
  components: {
    Navbar,
    SkuDetails
  },
  data () {
    return {
      // types: [
      //   { name: '申请退货', icon: require('../assets/img/sales-return.png') },
      //   { name: '申请换货', icon: require('../assets/img/exchange-goods.png') }
      // ]
      typeList: []
    }
  },
  computed: {
    ...mapState('afterSale', [
      'afterSaleSku'
    ])
  },
  created () {
    this.getSkuType()
  },
  methods: {
    async getSkuType () {
      const res = await this.$axios.post('api/refund/refund-type', { child_trade_id: this.afterSaleSku.child_trade_id, sku_id: this.afterSaleSku.sku_id })
      if (res.status === 200) {
        const { code, data, msg } = res.data
        if (code === 0) {
          this.typeList = data
          this.typeList = this.typeList.map(v => {
            if (v.service_name.includes('换')) {
              v.icon = require('../assets/img/exchange-goods.png')
              v.name = '申请换货'
            } else if (v.service_name.includes('退')) {
              v.icon = require('../assets/img/sales-return.png')
              v.name = '申请退货'
            }
            return v
          })
        } else {
          this.$toast(msg)
        }
      }
    },
    apply (type) {
      this.$router.push({ name: 'afterSaleFillInfo', query: { type } })
    }
  }
}
</script>

<style lang="less" scoped>
.after-sale-type{
}
.check-types{
  padding: 0 0.2rem;
  img {
    width: 0.6rem;
    height: auto;
    margin-left: 0.4rem;
    margin-right: 0.3rem;
  }
  button {
    display: block;
    width: 100%;
    margin-top: 0.25rem;
    font-size: @fz32;
    color: @base;
    font-weight: bold;
    border: 0.5px solid #D3D3D3;
    border-radius: 0.14rem;
    background-color: #fff;
    &:disabled {
      color: #D6D6D6;
      border-color: #D6D6D6;
    }
  }
  .type-intro {
    height: 0.88rem;
    display: flex;
    align-items: center;
  }
}
</style>
